/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Magnify_TitleInputs */

const en_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnify Preview`)
};

const fr_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrandir la previsualisation`)
};

const de_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau vergrößern`)
};

const it_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci Anteprima`)
};

const ru_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить Предварительный просмотр`)
};

const es_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar vista previa`)
};

const zh_cn2_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大预览`)
};

const ja_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューを拡大`)
};

const hi_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम करके पूर्वावलोकन देखें`)
};

const pt_pt2_video_export_preview_magnify_title = /** @type {(inputs: Video_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar pré-visualização`)
};

/**
* | output |
* | --- |
* | "Magnify Preview" |
*
* @param {Video_Export_Preview_Magnify_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_magnify_title = /** @type {((inputs?: Video_Export_Preview_Magnify_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Magnify_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_magnify_title(inputs)
	if (locale === "de") return de_video_export_preview_magnify_title(inputs)
	if (locale === "it") return it_video_export_preview_magnify_title(inputs)
	if (locale === "ru") return ru_video_export_preview_magnify_title(inputs)
	if (locale === "es") return es_video_export_preview_magnify_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_magnify_title(inputs)
	if (locale === "ja") return ja_video_export_preview_magnify_title(inputs)
	if (locale === "hi") return hi_video_export_preview_magnify_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_magnify_title(inputs)
	return en_video_export_preview_magnify_title(inputs)
});